import { Button, Center, Divider, Flex, Grid, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Text, useToast, VStack } from '@chakra-ui/react'
import GlucoseValues from './GlucoseValues'
import { useGetGlucose } from 'hooks/useGlucoseRegister'
import dateFormat from 'functions/dateFormat'
import { useNavigate } from 'react-router-dom'
import { useLazyQuery, useMutation } from '@apollo/client'
import { GET_GLUCOSE_REPORT } from 'queries/reportQueries'
import { downloadBinaryReport } from 'functions/reports'
import { DownloadIcon, LinkIcon } from '@phosphor-icons/react'
import { SEND_GLUCOSE_LINK } from 'queries/glucoseQueries'

interface Props {
    isOpen: boolean
    onClose: () => void,
    id: string
}

const SendLink = ({ isOpen, onClose, id }: Props) => {
    const [send, { loading }] = useMutation(SEND_GLUCOSE_LINK, {
        onCompleted: () => {
            toast({
                id: "linkSent",
                title: `Link enviado`,
                duration: 4000,
                position: "bottom",
                status: "success"
            }),
            onClose()
        }
    });
    const toast = useToast()

    const onSend = () => {
        send({
            variables: {
                id
            }
        })
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>
                    <Text>Enviar Link</Text>
                </ModalHeader>
                <ModalBody>
                    <Flex w="full" h="full" mb={6} >
                        <Text fontSize="md">Confirmar envio do link.</Text>
                    </Flex>
                </ModalBody>
                <ModalFooter gap={2}>
                    <Button colorScheme='green' onClick={onSend} leftIcon={<LinkIcon weight="bold" />} isLoading={loading} disabled={loading}>Enviar</Button>
                    <Button colorScheme="red" onClick={onClose} disabled={loading} >Fechar</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default SendLink